<template>
  <v-container fill-height fluid grid-list-md class="custom--container">
    <v-row v-for="(obj, index) of skills.programming" :key="index">
      <v-col>
        <animated-bar
          :id="'plang-' + index"
          :observer="observer"
          :bar="obj"
          :bus="bus"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AnimatedBar from "./bars/AnimatedBar.vue";
import { bus } from "../main";
export default {
  name: "Skills",
  props: ["skills"],
  components: { AnimatedBar },
  data() {
    return {
      observer: null,
      bus: bus,
    };
  },
  created() {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 1.0,
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }
        bus.$emit(target.id);
        // this.observer.unobserve(target);
      });
    },
  },
};
</script>
